import React, { useState } from 'react';
import { Card, Row, Col, List, DatePicker, Spin, Switch, Modal, Button } from 'antd';
import Background from '../../../../static/img/bg-list-title.png';
import { queryTicketsList, queryZendeskProjectConfig, queryJiraMembers, queryFeedbackLevels } from './gqls'
import Client from '../../../../lib/gqlClient';
import moment from 'moment-timezone';
import { useLocation } from 'react-router-dom';
import FeedbackItem from './item';
import FeedbackSearch from './search';
import FeedbackDetailsPage from '../feedbackDetails';
import axios from 'axios';
import { APP_BASE_URL } from '../../../../static/constant/index'
const MyVitalsFeedbackList = (props) => {
    const location = useLocation()
    const { state } = location
    const { RangePicker } = DatePicker;

    const [isGetData, setIsGetData] = useState(false)
    const [total, setTotal] = useState(1)
    const [startDate, setStartDate] = useState('')
    const [endDate, seteEndDate] = useState('')
    const [dataList, setDataList] = useState([])
    const [showSize, setShowSize] = useState(8)

    //接口请求数据
    const [oldSearch, setOldSearch] = useState(null)
    const [customerSource, setCustomerSource] = useState("")
    const [ticketId, setTicketId] = useState(null)
    const [page, setPage] = useState(1)
    const [deviceModel, setDeviceModel] = useState('')
    const [level1, setLevel1] = useState('')
    const [level2, setLevel2] = useState('')
    const [appVersion, setAppVersion] = useState('')
    const [phoneOS, setPhoneOS] = useState('')
    const [deviceType, setDeviceType] = useState('')
    const [fv, setFV] = useState('')
    const [hv, setHV] = useState('')
    const [phoneDevice, setPhoneDevice] = useState('')
    const [mac, setMac] = useState('')
    const [appId, setAppId] = useState('')
    const [channel, setChannel] = useState('')
    const [ignore, setIgnore] = useState(true)
    const [category, setCategory] = useState("myVitals4")
    //jira数据
    const [jira, setJiraList] = useState([])
    const [JiraMembers, setJiraMembersList] = useState([])
    const [feedbackLevels, setFeedbackLevels] = useState([])

    const [openView, setOpenView] = useState(false);
    const [openExport, setOpenExport] = useState(false);
    const [tickets, setTickets] = useState('');

    React.useEffect(() => {
        getZendeskProjectConfig()
        getJiraMembers()
        getFeedbackLevels()
        getTicketsList(page, startDate, endDate, showSize, ignore)
    }, [])
    function getTicketsList(page, startDate, endDate, count, ignore) {
        setIsGetData(true)
        if (count !== showSize) {
            setShowSize(count)
        }
        Client(
            queryTicketsList,
            {
                page: page,
                count: count,
                ticketsListId: parseInt(ticketId),
                level1: level1,
                level2: level2,
                startDate: startDate,
                endDate: endDate,
                deviceType: deviceType,
                deviceModel: deviceModel,
                fv: fv,
                hv: hv,
                appVersion: appVersion,
                phoneModel: phoneDevice,
                phoneOs: phoneOS,
                mac: mac,
                appId: appId,
                channel: channel,
                ignore: ignore,
                category: category,
                customerSource: customerSource
            }
        ).then((res) => {
            console.log(res)
            if (res !== null) {
                setDataList(res.data.ticketsList.data)
                setTotal(res.data.ticketsList.total)
            }
            setIsGetData(false)
        }).catch(e => {
            // console.log(e);
            setIsGetData(false)
        })
    }
    function onRefresh() {
        getTicketsList(page, startDate, endDate, showSize, ignore)
    }
    function getZendeskProjectConfig() {
        Client(
            queryZendeskProjectConfig,
            {}
        ).then((res) => {
            if (res !== null) {
                setJiraList(res.data.zendeskProjectConfig)
                console.log('jira', jira);
            }

        }).catch(e => {
            // console.log(e);

        })
    }
    function getJiraMembers() {
        Client(
            queryJiraMembers,
            {}
        ).then((res) => {
            if (res !== null) {
                setJiraMembersList(res.data.jiraMembers)
                console.log('jiraMembers', JiraMembers);
            }

        }).catch(e => {
            // console.log(e);

        })
    }
    function getFeedbackLevels() {
        Client(
            queryFeedbackLevels,
            {}
        ).then((res) => {
            if (res !== null) {
                setFeedbackLevels(res.data.feedbackLevels)
                console.log('FeedbackLevels', res);
            }

        }).catch(e => {
            // console.log(e);

        })
    }
    //搜索
    function onSearch(search) {
        console.log("newSearch:", search)
        setTicketId(search.ticketId)
        setDeviceModel(search.deviceModel)
        setCustomerSource(search.customerSource)
        setLevel1(search.level1)
        setLevel2(search.level2)
        setAppVersion(search.appVersion)
        setPhoneOS(search.phoneOS)
        setDeviceType(search.deviceType)
        setFV(search.fv)
        setHV(search.hv)
        setPhoneDevice(search.phoneDevice)
        setMac(search.mac)
        setAppId(search.appId)
        setChannel(search.channel)
        setIgnore(search.ignore)
        if (oldSearch !== null && oldSearch !== search) {
            setPage(1)
        }
        setOldSearch(search)
        setIsGetData(true)
        Client(
            queryTicketsList,
            {
                page: page,
                count: showSize,
                ticketsListId: parseInt(search.ticketId),
                level1: search.level1,
                level2: search.level2,
                startDate: startDate,
                endDate: endDate,
                deviceType: search.deviceType,
                deviceModel: search.deviceModel,
                fv: search.fv,
                hv: search.hv,
                appVersion: search.appVersion,
                phoneModel: search.phoneDevice,
                phoneOs: search.phoneOS,
                mac: search.mac,
                appId: search.appId,
                channel: search.channel,
                ignore: search.ignore,
                category: category,
                customerSource: search.customerSource
            }
        ).then((res) => {
            console.log(res)
            if (res !== null) {
                setDataList(res.data.ticketsList.data)
                setTotal(res.data.ticketsList.total)
            }
            setIsGetData(false)
        }).catch(e => {
            // console.log(e);
            setIsGetData(false)
        })
    }

    //调整时间段
    function onChange(date, dateString) {
        console.log(date, dateString);
        if (date != null) {
            // const start = moment(date[0]).utc().valueOf()
            // const end = moment(date[1]).utc().valueOf()
            const start=new Date(dateString[0]).getTime()
            const end=new Date(dateString[1]).getTime()
            setStartDate(start)
            seteEndDate(end)
            getTicketsList(1, start, end, showSize, ignore)
        } else {
            setStartDate('')
            seteEndDate('')
            getTicketsList(1, '', '', showSize, ignore)
        }
    }
    function setLoding(isLoding) {
        setIsGetData(isLoding)
    }
    const onChangeSwitch = (checked) => {
        setIgnore(checked)
        getTicketsList(page, startDate, endDate, showSize, checked)
    }
    function showDetail(item) {
        setOpenView(true)
        setTickets(item)
    }
    function exportList() {
        setOpenExport(false)
        const token = sessionStorage.getItem("sessionToken")
        var start = startDate
        var end = endDate
        if (startDate === "") {
            var now = new Date();
            var year = now.getFullYear(); // 年
            var month = now.getMonth() + 1; // 月
            var date = now.getDate(); // 日
            var time1=year+(month<10?"-0":"-")+month+(date<10?"-0":"-")+date
            if(month<3){
                year=year-1;
                month=12+month-3 
               
            }else{
                month=month-3 
            }
            var time2=year+(month<10?"-0":"-")+month+(date<10?"-0":"-")+date
            start = new Date(time2).getTime()
            end = new Date(time1).getTime()
            console.log(start,time2)
            console.log(end,time1)
        }
        axios.get(APP_BASE_URL + 'csv-file/feedbacks'
            , {
                params: {
                    startDate: start,
                    endDate: end
                },
                headers: {
                    authorization: token
                },
                responseType: 'blob'

            }).then((res) => {
                let resData = res.data;
                const blob = new Blob([resData], {
                    type: 'text/csv,charset=UTF-8'
                });
                const fileName = "feedback";
                if ('download' in document.createElement('a')) {
                    // 非IE下载
                    const elink = document.createElement('a');
                    elink.download = fileName;
                    elink.style.display = 'none';
                    elink.href = URL.createObjectURL(blob);
                    document.body.appendChild(elink);
                    elink.click();
                    URL.revokeObjectURL(elink.href); // 释放URL 对象
                    document.body.removeChild(elink);
                } else {
                    // IE10+下载
                    navigator.msSaveBlob(blob, fileName);
                }
            }).catch((error) => {


            });
    }

    return (
        <div style={{ height: '100%', width: '100%', }}>
            <FeedbackSearch onSearch={onSearch} history={state} style={{ width: '100%', }} />
            <Card bordered={false} style={{ marginTop: '25px', marginBottom: '25px', padding: '0px', }}>
                <div style={Styles.listTitle}>反馈列表</div>
                <div style={{ display: 'flex', justifyContent: 'right', alignItems: 'center', }}>
                    <div>ignore:</div>
                    <Switch style={{ marginRight: '10px', marginLeft: '5px', }}
                        checkedChildren="hide" unCheckedChildren="show" defaultChecked onChange={onChangeSwitch} />

                    <Button onClick={() => setOpenExport(true)} style={{ fontSize: '14px', width: '96px', height: '32px' }}>
                        <Row style={{ fontSize: '14px', width: '96px', height: '32px' }}>
                            <div style={{ color: 'rgba(0, 0, 0, 0.65)' }}>
                                Export
                            </div>
                            <img style={{ width: '20px', height: '20px', marginLeft: '5px', marginTop: '2px' }} src={require('../../../../static/img/icon_export.png')} />
                        </Row>

                    </Button>
                    <RangePicker onChange={onChange} style={{ height: '32px', width: '256px', marginLeft: '15px', }} />
                    <Modal
                        centered
                        open={openExport}
                        footer={null}
                        closable={false}
                        width={'440px'}
                        destroyOnClose={true}
                        maskClosable={true}
                        maskStyle={{ animation: 'none', background: 'ffffff', opacity: '0.5', padding: '0px', }}
                        bodyStyle={{ padding: '0px', width: '440px', height: '266px', }}
                        style={{ borderRadius: "10px", overflow: "auto" }}>
                        <div style={{
                            height: '65px', color: '#000000', fontSize: '16px',
                            display: 'flex', justifyContent: 'center', alignItems: 'center',
                        }}>
                            Export Feedback
                        </div>
                        <div style={{ height: '1px', background: '#E9E9E9' }}></div>
                        <div style={{
                            height: '72px', color: '#000000', fontSize: '14px',
                            display: 'flex', justifyContent: 'center', alignItems: 'end',
                        }}>
                            Are you sure you want to export this data？
                        </div>
                        <Row style={{
                            display: 'flex', justifyContent: 'right', alignItems: 'center',
                            marginTop: '45px', marginRight: '65px'
                        }}>
                            <Button onClick={() => setOpenExport(false)} style={{ fontSize: '14px', width: '80px', height: '32px' }}>Cancel</Button>
                            <Button onClick={exportList}
                                style={{
                                    fontSize: '14px', background: '#FF5300', color: 'white',
                                    width: '80px', height: '32px', marginLeft: '14px'
                                }}>
                                Export</Button>
                        </Row>

                    </Modal>

                </div>
                <Row style={Styles.listTitleBg}>
                    <Col span={2} style={Styles.listTitleText}>
                        <div style={{ marginLeft: '8px', }}> Ticket ID</div>
                    </Col>
                    <Col span={4} style={Styles.listTitleText}>
                        <div>Level1 name</div>
                        <div>Level2 name</div>
                    </Col>
                    <Col span={3} style={Styles.listTitleText}>
                        <div >Device type</div>
                        <div>Device Model</div>
                        <div>Firmware Version</div>
                        <div>Hardware Version</div>
                        <div>MAC</div>
                    </Col>
                    <Col span={4} style={Styles.listTitleText}>
                        <div >App Version</div>
                        <div>Client Phone Device</div>
                        <div>Phone OS</div>
                    </Col>
                    <Col span={6} style={Styles.listTitleText}>
                        <div >Content</div>
                    </Col>
                    <Col span={3} style={Styles.listTitleText}>
                        <div >Create Time</div>
                    </Col>
                    <Col span={2} style={Styles.listTitleText}>
                        <div >Operation</div>
                    </Col>
                </Row>
                <Spin size="large" tip="Loading..." spinning={isGetData} >

                    <List
                        itemLayout="vertical"
                        split="true"
                        pagination={{
                            onChange: (page, pageSize) => {
                                console.log(page);
                                setPage(page)
                                getTicketsList(page, startDate, endDate, pageSize, ignore)
                            },
                            pageSize: showSize,
                            hideOnSinglePage: true,
                            pageSizeOptions: [8, 10, 15, 20, 30, 50, 80, 100],
                            current: page,
                            total: total
                        }}
                        position="bottom"
                        dataSource={dataList}
                        renderItem={(item) => (
                            <FeedbackItem
                                item={item}
                                jira={jira}
                                JiraMembers={JiraMembers}
                                onRefresh={onRefresh}
                                setLoding={setLoding}
                                showDetail={showDetail}
                            />
                        )}
                    />
                </Spin>
                <Modal
                    closable={true}
                    centered
                    onCancel={(e) => { setOpenView(false) }}
                    open={openView}
                    footer={null}
                    width={"80%"}
                    destroyOnClose={true}
                    maskClosable={true}
                    maskStyle={{ animation: 'none', background: 'ffffff', opacity: '0.5', padding: '0px', }}
                    bodyStyle={{ padding: '0px', width: '100%', height: '100%', }}
                    style={{ borderRadius: "10px", overflow: "auto" }}>
                    <FeedbackDetailsPage
                        tickets={tickets}
                        feedbackLevels={feedbackLevels}
                        onRefresh={onRefresh}
                        setLoding={setLoding}
                    />
                </Modal>
            </Card>

        </div>
    );

}

const Styles = {
    listTitle: {
        display: 'block',
        fontSize: '16px',
        color: '#000000',
        marginTop: '25px',
        textAlign: 'center'

    },
    listTitleBg: {
        height: '115px',
        backgroundImage: `url(${Background})`,
        backgroundSize: '100%, 100%',
        marginTop: '17px',
        display: 'flex',
        alignItems: 'center',
    },
    listTitleText: {
        fontSize: '14px',
        paddingLeft: '8px',
        paddingRight: '8px',
    },
    item: {
        minHeight: '108px',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100%, 100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    }, inputText: {
        fontSize: '14px',
        width: '244px',
        borderRadius: '2px',
        height: '32px'
    }, itemTitle: {
        width: '200px',
        height: '32px',
        display: 'flex',
        justifyContent: 'right',
        alignItems: 'center',
        fontSize: '16px',
        paddingRight: '10px',
        paddingLeft: '0px',
        fontSize: '14px'
    },
}
export default MyVitalsFeedbackList